// source: report_page/consultant_report.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = (function() { return this || window || global || self || Function('return this')(); }).call(null);

goog.exportSymbol('proto.adx.consultant_report.GetConsultantCategoryMonthlyReportRequest', null, global);
goog.exportSymbol('proto.adx.consultant_report.GetConsultantCategoryMonthlyReportResponse', null, global);
goog.exportSymbol('proto.adx.consultant_report.GetConsultantCategoryMonthlyReportResponse.Report', null, global);
goog.exportSymbol('proto.adx.consultant_report.GetConsultantCategoryMonthlyReportResponse.Result', null, global);
goog.exportSymbol('proto.adx.consultant_report.GetConsultantCategoryMonthlyReportResponse.Table', null, global);
goog.exportSymbol('proto.adx.consultant_report.GetConsultantCategoryMonthlyReportResponse.TypeCase', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.adx.consultant_report.GetConsultantCategoryMonthlyReportRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.adx.consultant_report.GetConsultantCategoryMonthlyReportRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.adx.consultant_report.GetConsultantCategoryMonthlyReportRequest.displayName = 'proto.adx.consultant_report.GetConsultantCategoryMonthlyReportRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.adx.consultant_report.GetConsultantCategoryMonthlyReportResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.adx.consultant_report.GetConsultantCategoryMonthlyReportResponse.oneofGroups_);
};
goog.inherits(proto.adx.consultant_report.GetConsultantCategoryMonthlyReportResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.adx.consultant_report.GetConsultantCategoryMonthlyReportResponse.displayName = 'proto.adx.consultant_report.GetConsultantCategoryMonthlyReportResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.adx.consultant_report.GetConsultantCategoryMonthlyReportResponse.Table = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.adx.consultant_report.GetConsultantCategoryMonthlyReportResponse.Table, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.adx.consultant_report.GetConsultantCategoryMonthlyReportResponse.Table.displayName = 'proto.adx.consultant_report.GetConsultantCategoryMonthlyReportResponse.Table';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.adx.consultant_report.GetConsultantCategoryMonthlyReportResponse.Report = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.adx.consultant_report.GetConsultantCategoryMonthlyReportResponse.Report.repeatedFields_, null);
};
goog.inherits(proto.adx.consultant_report.GetConsultantCategoryMonthlyReportResponse.Report, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.adx.consultant_report.GetConsultantCategoryMonthlyReportResponse.Report.displayName = 'proto.adx.consultant_report.GetConsultantCategoryMonthlyReportResponse.Report';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.adx.consultant_report.GetConsultantCategoryMonthlyReportResponse.Result = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.adx.consultant_report.GetConsultantCategoryMonthlyReportResponse.Result.repeatedFields_, null);
};
goog.inherits(proto.adx.consultant_report.GetConsultantCategoryMonthlyReportResponse.Result, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.adx.consultant_report.GetConsultantCategoryMonthlyReportResponse.Result.displayName = 'proto.adx.consultant_report.GetConsultantCategoryMonthlyReportResponse.Result';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.adx.consultant_report.GetConsultantCategoryMonthlyReportRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.adx.consultant_report.GetConsultantCategoryMonthlyReportRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.adx.consultant_report.GetConsultantCategoryMonthlyReportRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.adx.consultant_report.GetConsultantCategoryMonthlyReportRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    requestid: jspb.Message.getFieldWithDefault(msg, 1, ""),
    advertizerid: jspb.Message.getFieldWithDefault(msg, 2, 0),
    actualmonth: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.adx.consultant_report.GetConsultantCategoryMonthlyReportRequest}
 */
proto.adx.consultant_report.GetConsultantCategoryMonthlyReportRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.adx.consultant_report.GetConsultantCategoryMonthlyReportRequest;
  return proto.adx.consultant_report.GetConsultantCategoryMonthlyReportRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.adx.consultant_report.GetConsultantCategoryMonthlyReportRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.adx.consultant_report.GetConsultantCategoryMonthlyReportRequest}
 */
proto.adx.consultant_report.GetConsultantCategoryMonthlyReportRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setRequestid(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setAdvertizerid(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setActualmonth(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.adx.consultant_report.GetConsultantCategoryMonthlyReportRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.adx.consultant_report.GetConsultantCategoryMonthlyReportRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.adx.consultant_report.GetConsultantCategoryMonthlyReportRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.adx.consultant_report.GetConsultantCategoryMonthlyReportRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRequestid();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getAdvertizerid();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getActualmonth();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional string requestId = 1;
 * @return {string}
 */
proto.adx.consultant_report.GetConsultantCategoryMonthlyReportRequest.prototype.getRequestid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.adx.consultant_report.GetConsultantCategoryMonthlyReportRequest} returns this
 */
proto.adx.consultant_report.GetConsultantCategoryMonthlyReportRequest.prototype.setRequestid = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional int32 advertizerId = 2;
 * @return {number}
 */
proto.adx.consultant_report.GetConsultantCategoryMonthlyReportRequest.prototype.getAdvertizerid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.adx.consultant_report.GetConsultantCategoryMonthlyReportRequest} returns this
 */
proto.adx.consultant_report.GetConsultantCategoryMonthlyReportRequest.prototype.setAdvertizerid = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional string actualMonth = 3;
 * @return {string}
 */
proto.adx.consultant_report.GetConsultantCategoryMonthlyReportRequest.prototype.getActualmonth = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.adx.consultant_report.GetConsultantCategoryMonthlyReportRequest} returns this
 */
proto.adx.consultant_report.GetConsultantCategoryMonthlyReportRequest.prototype.setActualmonth = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.adx.consultant_report.GetConsultantCategoryMonthlyReportResponse.oneofGroups_ = [[1,2]];

/**
 * @enum {number}
 */
proto.adx.consultant_report.GetConsultantCategoryMonthlyReportResponse.TypeCase = {
  TYPE_NOT_SET: 0,
  RESULT: 1,
  ERROR: 2
};

/**
 * @return {proto.adx.consultant_report.GetConsultantCategoryMonthlyReportResponse.TypeCase}
 */
proto.adx.consultant_report.GetConsultantCategoryMonthlyReportResponse.prototype.getTypeCase = function() {
  return /** @type {proto.adx.consultant_report.GetConsultantCategoryMonthlyReportResponse.TypeCase} */(jspb.Message.computeOneofCase(this, proto.adx.consultant_report.GetConsultantCategoryMonthlyReportResponse.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.adx.consultant_report.GetConsultantCategoryMonthlyReportResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.adx.consultant_report.GetConsultantCategoryMonthlyReportResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.adx.consultant_report.GetConsultantCategoryMonthlyReportResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.adx.consultant_report.GetConsultantCategoryMonthlyReportResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    result: (f = msg.getResult()) && proto.adx.consultant_report.GetConsultantCategoryMonthlyReportResponse.Result.toObject(includeInstance, f),
    error: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.adx.consultant_report.GetConsultantCategoryMonthlyReportResponse}
 */
proto.adx.consultant_report.GetConsultantCategoryMonthlyReportResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.adx.consultant_report.GetConsultantCategoryMonthlyReportResponse;
  return proto.adx.consultant_report.GetConsultantCategoryMonthlyReportResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.adx.consultant_report.GetConsultantCategoryMonthlyReportResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.adx.consultant_report.GetConsultantCategoryMonthlyReportResponse}
 */
proto.adx.consultant_report.GetConsultantCategoryMonthlyReportResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.adx.consultant_report.GetConsultantCategoryMonthlyReportResponse.Result;
      reader.readMessage(value,proto.adx.consultant_report.GetConsultantCategoryMonthlyReportResponse.Result.deserializeBinaryFromReader);
      msg.setResult(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setError(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.adx.consultant_report.GetConsultantCategoryMonthlyReportResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.adx.consultant_report.GetConsultantCategoryMonthlyReportResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.adx.consultant_report.GetConsultantCategoryMonthlyReportResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.adx.consultant_report.GetConsultantCategoryMonthlyReportResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getResult();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.adx.consultant_report.GetConsultantCategoryMonthlyReportResponse.Result.serializeBinaryToWriter
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 2));
  if (f != null) {
    writer.writeString(
      2,
      f
    );
  }
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.adx.consultant_report.GetConsultantCategoryMonthlyReportResponse.Table.prototype.toObject = function(opt_includeInstance) {
  return proto.adx.consultant_report.GetConsultantCategoryMonthlyReportResponse.Table.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.adx.consultant_report.GetConsultantCategoryMonthlyReportResponse.Table} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.adx.consultant_report.GetConsultantCategoryMonthlyReportResponse.Table.toObject = function(includeInstance, msg) {
  var f, obj = {
    key: jspb.Message.getFieldWithDefault(msg, 1, ""),
    value: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.adx.consultant_report.GetConsultantCategoryMonthlyReportResponse.Table}
 */
proto.adx.consultant_report.GetConsultantCategoryMonthlyReportResponse.Table.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.adx.consultant_report.GetConsultantCategoryMonthlyReportResponse.Table;
  return proto.adx.consultant_report.GetConsultantCategoryMonthlyReportResponse.Table.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.adx.consultant_report.GetConsultantCategoryMonthlyReportResponse.Table} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.adx.consultant_report.GetConsultantCategoryMonthlyReportResponse.Table}
 */
proto.adx.consultant_report.GetConsultantCategoryMonthlyReportResponse.Table.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setKey(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setValue(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.adx.consultant_report.GetConsultantCategoryMonthlyReportResponse.Table.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.adx.consultant_report.GetConsultantCategoryMonthlyReportResponse.Table.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.adx.consultant_report.GetConsultantCategoryMonthlyReportResponse.Table} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.adx.consultant_report.GetConsultantCategoryMonthlyReportResponse.Table.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getKey();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getValue();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string key = 1;
 * @return {string}
 */
proto.adx.consultant_report.GetConsultantCategoryMonthlyReportResponse.Table.prototype.getKey = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.adx.consultant_report.GetConsultantCategoryMonthlyReportResponse.Table} returns this
 */
proto.adx.consultant_report.GetConsultantCategoryMonthlyReportResponse.Table.prototype.setKey = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string value = 2;
 * @return {string}
 */
proto.adx.consultant_report.GetConsultantCategoryMonthlyReportResponse.Table.prototype.getValue = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.adx.consultant_report.GetConsultantCategoryMonthlyReportResponse.Table} returns this
 */
proto.adx.consultant_report.GetConsultantCategoryMonthlyReportResponse.Table.prototype.setValue = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.adx.consultant_report.GetConsultantCategoryMonthlyReportResponse.Report.repeatedFields_ = [3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.adx.consultant_report.GetConsultantCategoryMonthlyReportResponse.Report.prototype.toObject = function(opt_includeInstance) {
  return proto.adx.consultant_report.GetConsultantCategoryMonthlyReportResponse.Report.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.adx.consultant_report.GetConsultantCategoryMonthlyReportResponse.Report} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.adx.consultant_report.GetConsultantCategoryMonthlyReportResponse.Report.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, ""),
    name: jspb.Message.getFieldWithDefault(msg, 2, ""),
    tableList: jspb.Message.toObjectList(msg.getTableList(),
    proto.adx.consultant_report.GetConsultantCategoryMonthlyReportResponse.Table.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.adx.consultant_report.GetConsultantCategoryMonthlyReportResponse.Report}
 */
proto.adx.consultant_report.GetConsultantCategoryMonthlyReportResponse.Report.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.adx.consultant_report.GetConsultantCategoryMonthlyReportResponse.Report;
  return proto.adx.consultant_report.GetConsultantCategoryMonthlyReportResponse.Report.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.adx.consultant_report.GetConsultantCategoryMonthlyReportResponse.Report} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.adx.consultant_report.GetConsultantCategoryMonthlyReportResponse.Report}
 */
proto.adx.consultant_report.GetConsultantCategoryMonthlyReportResponse.Report.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 3:
      var value = new proto.adx.consultant_report.GetConsultantCategoryMonthlyReportResponse.Table;
      reader.readMessage(value,proto.adx.consultant_report.GetConsultantCategoryMonthlyReportResponse.Table.deserializeBinaryFromReader);
      msg.addTable(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.adx.consultant_report.GetConsultantCategoryMonthlyReportResponse.Report.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.adx.consultant_report.GetConsultantCategoryMonthlyReportResponse.Report.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.adx.consultant_report.GetConsultantCategoryMonthlyReportResponse.Report} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.adx.consultant_report.GetConsultantCategoryMonthlyReportResponse.Report.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getTableList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      proto.adx.consultant_report.GetConsultantCategoryMonthlyReportResponse.Table.serializeBinaryToWriter
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.adx.consultant_report.GetConsultantCategoryMonthlyReportResponse.Report.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.adx.consultant_report.GetConsultantCategoryMonthlyReportResponse.Report} returns this
 */
proto.adx.consultant_report.GetConsultantCategoryMonthlyReportResponse.Report.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string name = 2;
 * @return {string}
 */
proto.adx.consultant_report.GetConsultantCategoryMonthlyReportResponse.Report.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.adx.consultant_report.GetConsultantCategoryMonthlyReportResponse.Report} returns this
 */
proto.adx.consultant_report.GetConsultantCategoryMonthlyReportResponse.Report.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * repeated Table table = 3;
 * @return {!Array<!proto.adx.consultant_report.GetConsultantCategoryMonthlyReportResponse.Table>}
 */
proto.adx.consultant_report.GetConsultantCategoryMonthlyReportResponse.Report.prototype.getTableList = function() {
  return /** @type{!Array<!proto.adx.consultant_report.GetConsultantCategoryMonthlyReportResponse.Table>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.adx.consultant_report.GetConsultantCategoryMonthlyReportResponse.Table, 3));
};


/**
 * @param {!Array<!proto.adx.consultant_report.GetConsultantCategoryMonthlyReportResponse.Table>} value
 * @return {!proto.adx.consultant_report.GetConsultantCategoryMonthlyReportResponse.Report} returns this
*/
proto.adx.consultant_report.GetConsultantCategoryMonthlyReportResponse.Report.prototype.setTableList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.adx.consultant_report.GetConsultantCategoryMonthlyReportResponse.Table=} opt_value
 * @param {number=} opt_index
 * @return {!proto.adx.consultant_report.GetConsultantCategoryMonthlyReportResponse.Table}
 */
proto.adx.consultant_report.GetConsultantCategoryMonthlyReportResponse.Report.prototype.addTable = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.adx.consultant_report.GetConsultantCategoryMonthlyReportResponse.Table, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.adx.consultant_report.GetConsultantCategoryMonthlyReportResponse.Report} returns this
 */
proto.adx.consultant_report.GetConsultantCategoryMonthlyReportResponse.Report.prototype.clearTableList = function() {
  return this.setTableList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.adx.consultant_report.GetConsultantCategoryMonthlyReportResponse.Result.repeatedFields_ = [3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.adx.consultant_report.GetConsultantCategoryMonthlyReportResponse.Result.prototype.toObject = function(opt_includeInstance) {
  return proto.adx.consultant_report.GetConsultantCategoryMonthlyReportResponse.Result.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.adx.consultant_report.GetConsultantCategoryMonthlyReportResponse.Result} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.adx.consultant_report.GetConsultantCategoryMonthlyReportResponse.Result.toObject = function(includeInstance, msg) {
  var f, obj = {
    requestid: jspb.Message.getFieldWithDefault(msg, 1, ""),
    structure: jspb.Message.getFieldWithDefault(msg, 2, ""),
    reportList: jspb.Message.toObjectList(msg.getReportList(),
    proto.adx.consultant_report.GetConsultantCategoryMonthlyReportResponse.Report.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.adx.consultant_report.GetConsultantCategoryMonthlyReportResponse.Result}
 */
proto.adx.consultant_report.GetConsultantCategoryMonthlyReportResponse.Result.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.adx.consultant_report.GetConsultantCategoryMonthlyReportResponse.Result;
  return proto.adx.consultant_report.GetConsultantCategoryMonthlyReportResponse.Result.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.adx.consultant_report.GetConsultantCategoryMonthlyReportResponse.Result} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.adx.consultant_report.GetConsultantCategoryMonthlyReportResponse.Result}
 */
proto.adx.consultant_report.GetConsultantCategoryMonthlyReportResponse.Result.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setRequestid(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setStructure(value);
      break;
    case 3:
      var value = new proto.adx.consultant_report.GetConsultantCategoryMonthlyReportResponse.Report;
      reader.readMessage(value,proto.adx.consultant_report.GetConsultantCategoryMonthlyReportResponse.Report.deserializeBinaryFromReader);
      msg.addReport(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.adx.consultant_report.GetConsultantCategoryMonthlyReportResponse.Result.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.adx.consultant_report.GetConsultantCategoryMonthlyReportResponse.Result.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.adx.consultant_report.GetConsultantCategoryMonthlyReportResponse.Result} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.adx.consultant_report.GetConsultantCategoryMonthlyReportResponse.Result.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRequestid();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getStructure();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getReportList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      proto.adx.consultant_report.GetConsultantCategoryMonthlyReportResponse.Report.serializeBinaryToWriter
    );
  }
};


/**
 * optional string requestId = 1;
 * @return {string}
 */
proto.adx.consultant_report.GetConsultantCategoryMonthlyReportResponse.Result.prototype.getRequestid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.adx.consultant_report.GetConsultantCategoryMonthlyReportResponse.Result} returns this
 */
proto.adx.consultant_report.GetConsultantCategoryMonthlyReportResponse.Result.prototype.setRequestid = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string structure = 2;
 * @return {string}
 */
proto.adx.consultant_report.GetConsultantCategoryMonthlyReportResponse.Result.prototype.getStructure = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.adx.consultant_report.GetConsultantCategoryMonthlyReportResponse.Result} returns this
 */
proto.adx.consultant_report.GetConsultantCategoryMonthlyReportResponse.Result.prototype.setStructure = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * repeated Report report = 3;
 * @return {!Array<!proto.adx.consultant_report.GetConsultantCategoryMonthlyReportResponse.Report>}
 */
proto.adx.consultant_report.GetConsultantCategoryMonthlyReportResponse.Result.prototype.getReportList = function() {
  return /** @type{!Array<!proto.adx.consultant_report.GetConsultantCategoryMonthlyReportResponse.Report>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.adx.consultant_report.GetConsultantCategoryMonthlyReportResponse.Report, 3));
};


/**
 * @param {!Array<!proto.adx.consultant_report.GetConsultantCategoryMonthlyReportResponse.Report>} value
 * @return {!proto.adx.consultant_report.GetConsultantCategoryMonthlyReportResponse.Result} returns this
*/
proto.adx.consultant_report.GetConsultantCategoryMonthlyReportResponse.Result.prototype.setReportList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.adx.consultant_report.GetConsultantCategoryMonthlyReportResponse.Report=} opt_value
 * @param {number=} opt_index
 * @return {!proto.adx.consultant_report.GetConsultantCategoryMonthlyReportResponse.Report}
 */
proto.adx.consultant_report.GetConsultantCategoryMonthlyReportResponse.Result.prototype.addReport = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.adx.consultant_report.GetConsultantCategoryMonthlyReportResponse.Report, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.adx.consultant_report.GetConsultantCategoryMonthlyReportResponse.Result} returns this
 */
proto.adx.consultant_report.GetConsultantCategoryMonthlyReportResponse.Result.prototype.clearReportList = function() {
  return this.setReportList([]);
};


/**
 * optional Result result = 1;
 * @return {?proto.adx.consultant_report.GetConsultantCategoryMonthlyReportResponse.Result}
 */
proto.adx.consultant_report.GetConsultantCategoryMonthlyReportResponse.prototype.getResult = function() {
  return /** @type{?proto.adx.consultant_report.GetConsultantCategoryMonthlyReportResponse.Result} */ (
    jspb.Message.getWrapperField(this, proto.adx.consultant_report.GetConsultantCategoryMonthlyReportResponse.Result, 1));
};


/**
 * @param {?proto.adx.consultant_report.GetConsultantCategoryMonthlyReportResponse.Result|undefined} value
 * @return {!proto.adx.consultant_report.GetConsultantCategoryMonthlyReportResponse} returns this
*/
proto.adx.consultant_report.GetConsultantCategoryMonthlyReportResponse.prototype.setResult = function(value) {
  return jspb.Message.setOneofWrapperField(this, 1, proto.adx.consultant_report.GetConsultantCategoryMonthlyReportResponse.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.adx.consultant_report.GetConsultantCategoryMonthlyReportResponse} returns this
 */
proto.adx.consultant_report.GetConsultantCategoryMonthlyReportResponse.prototype.clearResult = function() {
  return this.setResult(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.adx.consultant_report.GetConsultantCategoryMonthlyReportResponse.prototype.hasResult = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional string error = 2;
 * @return {string}
 */
proto.adx.consultant_report.GetConsultantCategoryMonthlyReportResponse.prototype.getError = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.adx.consultant_report.GetConsultantCategoryMonthlyReportResponse} returns this
 */
proto.adx.consultant_report.GetConsultantCategoryMonthlyReportResponse.prototype.setError = function(value) {
  return jspb.Message.setOneofField(this, 2, proto.adx.consultant_report.GetConsultantCategoryMonthlyReportResponse.oneofGroups_[0], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.adx.consultant_report.GetConsultantCategoryMonthlyReportResponse} returns this
 */
proto.adx.consultant_report.GetConsultantCategoryMonthlyReportResponse.prototype.clearError = function() {
  return jspb.Message.setOneofField(this, 2, proto.adx.consultant_report.GetConsultantCategoryMonthlyReportResponse.oneofGroups_[0], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.adx.consultant_report.GetConsultantCategoryMonthlyReportResponse.prototype.hasError = function() {
  return jspb.Message.getField(this, 2) != null;
};


goog.object.extend(exports, proto.adx.consultant_report);
